<style scoped>
    .customer{
        display: block;
        margin-bottom: 5px;
    }
</style>
<template>
    <div class="customer-selector">
        <Poptip trigger="click" transfer :placement="placement">
            <Input :clearable="selected" :readonly="selected" :size="size" autocomplete="new-password" :value="value" @on-clear="cancelSelect" @on-change="inputChange" icon="person" />
            <div slot="content">
                <div class="color-error">公司员工可在此搜索</div>
                <!-- <div class="line">
                    <Button long size="small" type="primary" @click="setCustomer(cur_customer)">设为本人</Button>
                </div> -->
                <div class="line">
                    <i-input size="small" v-model="params.search" @on-enter="searchCustomer" @click.stop @focus.stop.prevent placeholder="搜索员工">
                        <Button slot="append" icon="ios-search" :loading="searching" @click="searchCustomer"></Button>
                    </i-input>
                </div>
                <Button size="small"
                        long
                        class="customer"
                        @click="setCustomer(customer)"
                        v-for="customer in customer_results"
                        :key="customer.id">
                    {{customer.account}} - {{customer.team_name}}
                </Button>
            </div>
        </Poptip>
    </div>
</template>
<script>
    import Util from '../../../libs/util';
    export default {
        props: {
            value: {
                type: String
            },
            size: {
                type: String,
                'default': ''
            },
            placement: {
                type: String,
                'default': 'bottom'
            },
            selected: {
                type: Boolean,
                'default': false
            }
        },
        data(){
            return {
                params: {
                    search: '',
                    page: 1,
                    per_page: 10,
                    quit: 0,
                    customer_type: -1
                },
                searching: false,
                customer_results: [],
            }
        },
        computed: {
            cur_customer(){
                return this.$store.state.cur_customer;
            },
        },
        created(){
            //
        },
        mounted(){
            //
            console.log('customer', this.selected)
        },
        methods: {
            cancelSelect () {
                this.$emit('cancel-select')
            },
            setCustomer(customer){
                this.$emit('input', customer.account);
                this.$emit('select', customer);
                document.body.click();
            },
            inputChange(event){
                this.$emit('input', event.target.value);
            },
            searchCustomer(){
                if(this.searching) return;
                this.searching = true;
                Util.ajax.get(Util.api.query_customer_travel_order_info, {
                    params: this.params
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    this.searching = false;
                    console.log(res);
                    if(res.code === 1){
                        let data = res.data;
                        this.customer_results = data.customers;
                        if(this.customer_results.length === 0){
                            this.$Message.warning('没有搜索到相关人员');
                        }
                    }else{
                        //失败
                        this.$Modal.warning({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    this.searching = false;
                    this.$Modal.warning({
                        title: '错误',
                        content: e.message
                    });
                });
            }
        }
    }
</script>
